import {
    makeStyles,
    shorthands,
    Menu,
    MenuTrigger,
    MenuPopover,
    MenuList,
    MenuItem,
    MenuButton,
    tokens,
    Overflow,
    OverflowItem,
    useIsOverflowItemVisible,
    useOverflowMenu,
    MenuProps,
} from "@fluentui/react-components";
import * as React from "react";
import { IUserProfile, NavItems } from "../../../types/User/IUserProfile";
import { useContext } from "react";
import { RevUserContext } from "../../../context/UserContext";
import NavButton, { INavButtonProps } from "./NavButton";
import ProfileNav, { ProfileNavProps } from "../ProfileNav/ProfileNav";
import { useLocation, useNavigate } from "react-router-dom";
import { NavLogoProps } from "../NavLogo";
import { TicketLocationState } from "../../Ticket/TicketRoute";
import { useReduxDispatch } from "../../../redux/hooks";
import { updateIframeSrc } from "../../../slices/RevelationSlice";
import { nanoid } from "nanoid";
import { trimChar } from "../../../utils/utils";
import { useGetTenantQuery } from "../../../redux/api/BaseApi";


const useStyles = makeStyles({
    container: {
        display: "flex",
        flexGrow: 1,
        flexWrap: "nowrap",
        minWidth: 0,

        ...shorthands.overflow("hidden"),
    },

    farItems: {
        display: "flex",
        ...shorthands.gap("4px"),
        flexWrap: "nowrap",
        // marginRight: "10px", //to allow the resize handle to be grabbed
    },

    resizableArea: {
        display: "flex",
        flexWrap: "nowrap",
        minWidth: "200px",
        ...shorthands.overflow("hidden"),
        position: "relative",
        "::after": {
            position: "absolute",
            top: "-2px",
            left: "-2px",
            fontFamily: "monospace",
            fontSize: "15px",
            fontWeight: 900,
            lineHeight: 1,
            letterSpacing: "1px",
            color: tokens.colorNeutralForegroundOnBrand,
            backgroundColor: tokens.colorBrandBackground,
        },
    },
});

export const FluentButtonBar = (props: NavLogoProps) => {
    const { data: tenant } = useGetTenantQuery();
    const data = useContext<IUserProfile>(RevUserContext);
    const { Nav_Items, Nav_Hex_Color } = data;
    const styles = useStyles();
    //const itemIds = Nav_Items?.map(n => n.Name)
    const [showNavMenu, setShowNavMenu] = React.useState<string>('false');
    //const itemIds = new Array(8).fill(0).map((_, i) => i.toString());
    const profileProps: ProfileNavProps = {
        data: data || {} as IUserProfile,
        mimicUid: null,
        navStyle: props.navStyle
    };
    return (
        <div className={styles.resizableArea + ' fluent-button-bar'}>
            <Overflow>
                <div className="nav-buttons-fluent hidden md:flex">
                    {
                        Nav_Items?.map((i) => (

                            <OverflowItem key={i.Name} id={i.Name}>
                                <MenuButton key={'b_' + i.Name} >
                                    <NavMenu key={'nv_' + i.Name} props={{ ...i, baseUrl: trimChar(tenant?.Tenant_Url, '/'), buttonColor: Nav_Hex_Color, navStyle: props.navStyle }} isTopLevel={true} />
                                </MenuButton>
                            </OverflowItem>

                        ))}
                    {
                        <NavMenu props={{ ...{ Nav_Items: Nav_Items, Image_Url: '/images/Nav/other.png', Name: 'more-items', isMoreItems: true } as INavButtonProps, baseUrl: trimChar(tenant?.Tenant_Url, '/'), buttonColor: Nav_Hex_Color, navStyle: props.navStyle }} isTopLevel={true} />

                    }
                </div>
            </Overflow>
            <div className={styles.farItems}>
                <ProfileNav props={profileProps} />
            </div>

        </div>
    );
};

const NavMenu: React.FC<{ props: INavButtonProps, isTopLevel: boolean }> = ({ props, isTopLevel }) => {
    const { ref, overflowCount, isOverflowing } = useOverflowMenu<HTMLButtonElement>();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useReduxDispatch();
    const [open, setOpen] = React.useState(false);
    const onOpenChange: MenuProps["onOpenChange"] = (e, data) => {
        //console.log('onOpenChange', data, props.Name)
        // if (data.type === 'menuTriggerClick')
        //     setOpen(false);
        // else
        if (props.Name === 'more-items' || data.type !== 'menuTriggerClick') {
            //console.log('setOpen = yes')
            setOpen(data.open);
        }
    };

    if (!isOverflowing && props.Name === 'more-items' && isTopLevel) {
        return null;
    }

    const text = props.isMoreItems ? `+${overflowCount} items` : props.Text;

    function handleOnClick(e) {
        console.warn('handleOnClick', props.Url);
        if (props.Url) {
            e.preventDefault();
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();

            if (props.Url.indexOf("./") === 0) {
                //internal URL, not IFrame
                const ticketState = {
                    background: location,
                } as unknown as TicketLocationState;

                //trim leading . from URL if it starts with a .
                let trimmedStr = props.Url.startsWith('.') ? props.Url.substring(1) : props.Url;
                console.warn('navigate', trimmedStr, props.Url, ticketState)
                navigate(trimmedStr, { state: ticketState });

                //navigate(props.Url, { state: ticketState });
                //navigate(item.Url);
            } else {
                navigate("/");

                dispatch(
                    updateIframeSrc(
                        `${props.Url}${props.Url.indexOf("?") > -1 ? "&" : "?"}d=${nanoid()}`
                    )
                );
            }
        }
        setTimeout(() => setOpen(false), 200);
        //setOpen(false);
        console.log('handleOnClick', open)
    }

    return (
        <Menu open={open} onOpenChange={onOpenChange}>
            <MenuTrigger>
                {props.isMoreItems ? <MenuButton ref={ref} className="top-level" > <NavButton
                    key={props.Name}
                    props={{ ...props, Text: text, onContextMenu: (e) => setOpen(true) }}
                /> </MenuButton> :
                    isTopLevel

                        ? <div className="absolute-nope"><NavButton
                            key={props.Name}
                            props={{ ...props, Text: text, onContextMenu: (e) => setOpen(true) }}
                        /></div>

                        : <MenuItem className="nav-overflow-item" style={{ height: 'auto' }}><div className="inline-flex" onClick={(e) => handleOnClick(e)} ><img className="mr-2" src={props.Image_Url ? '.' + trimChar(props.Image_Url, '.') : ''} style={{ maxWidth: '25px' }} height={'auto'} />{props.Text}</div></MenuItem>

                }
            </MenuTrigger>


            <MenuPopover style={{ backgroundColor: props.buttonColor, color: '#fff' }}>
                <MenuList>
                    <div className="nav-more-items-2">
                        {props.Nav_Items?.map((i) => {
                            return <NavMenuItem key={i.Name} props={{ ...i, baseUrl: props.baseUrl, buttonColor: props.buttonColor, navStyle: props.navStyle }}>
                            </NavMenuItem>
                        })}
                    </div>
                </MenuList>
            </MenuPopover>
        </Menu >
    );
};

const NavMenuItem: React.FC<{ props: INavButtonProps }> = ({ props }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useReduxDispatch();
    const data = useContext<IUserProfile>(RevUserContext);
    //const { id, children } = props;
    const isVisible = useIsOverflowItemVisible(props.Name);

    if (isVisible) {
        return null;
    }

    function handleOnClick(item: NavItems) {
        if (item.Url) {
            if (item.Url.indexOf("./") === 0) {
                //internal URL, not IFrame
                const ticketState = {
                    background: location,
                } as unknown as TicketLocationState;
                //navigate(item.Url, { state: ticketState });

                let trimmedStr = item.Url.startsWith('.') ? item.Url.substring(1) : item.Url;
                console.warn('navigate', trimmedStr, item.Url, ticketState)
                navigate(trimmedStr, { state: ticketState });
                //navigate(item.Url);
            } else {
                navigate("/");
                //console.log('item.Url', item.Url)
                dispatch(
                    updateIframeSrc(
                        `${item.Url}${item.Url.indexOf("?") > -1 ? "&" : "?"}d=${nanoid()}`
                    )
                );
            }
        }
    }

    if (props.Nav_Items?.length > 0)
        return <NavMenu key={props.Name} props={props} isTopLevel={false} />

    return <MenuItem className="nav-overflow-item nav-overflow-border">
        <div className="inline-flex" onClick={() => handleOnClick(props)} ><img className="mr-2" src={props.Image_Url && !props.Image_Url.startsWith('http') ? '.' + trimChar(props.Image_Url, '.') : props.Image_Url} style={{ maxWidth: '25px' }} height={'auto'} /><span dangerouslySetInnerHTML={{ __html: props.Text }}></span></div>
    </MenuItem>;
};

